import { omit } from "lodash";
import { create } from "zustand";

interface ExpandingSidebarState {
  searchValue: string;
}

interface ExpandingSidebarStore extends ExpandingSidebarState {
  actions: {
    setSearchValue: (value: string) => void;
    clearState: () => void;
  };
}

const initialState: ExpandingSidebarState = {
  searchValue: "",
};

const useExpandingSidebarStore = create<ExpandingSidebarStore>()((set) => ({
  ...initialState,
  actions: {
    setSearchValue: (value: string) => set({ searchValue: value }),
    clearState: () => set(initialState),
  },
}));

export const getExpandingSidebarState = () => useExpandingSidebarStore.getState();
export const useExpandingSidebarData = () => useExpandingSidebarStore((state) => omit(state, "actions"));
export const useExpandingSidebarActions = () => useExpandingSidebarStore((state) => state.actions);
